const REST_API__BASE = 'https://www.breakingbadapi.com/api';
export const REST_API__CHARACTERS = `${REST_API__BASE}/characters`;

const REST_API__QUOTES = `${REST_API__BASE}/quote`
export const REST_API__RANDOM_QUOTE = `${REST_API__QUOTES}/random`